import { isNil } from 'lodash';

import { ValidationRule } from '@/mixins/validation/validator';

export const required: ValidationRule = value => {
	const valid = !isNil(value) && value !== '';

	return valid || 'Field is required';
};
